import { render } from "./BlogSingle.vue?vue&type=template&id=0d63f1d2"
import script from "./BlogSingle.vue?vue&type=script&lang=js"
export * from "./BlogSingle.vue?vue&type=script&lang=js"

import "./BlogSingle.vue?vue&type=style&index=0&id=0d63f1d2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__